import vanillaScrollspy from './scrollspy/vanillajs-scrollspy';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.adam__scrollspy').forEach(function (el) {
        const scrollspy = vanillaScrollspy(el, 2000, 'easeOutSine', 80);
        scrollspy.init();
    });
});